/* NEAT — wjazd elementów przy przewijaniu (.ne-rv). Sekcje z własną logiką mają swoje skrypty. */
(function () {
  document.documentElement.classList.add('ne-js');
  function start() {
    var els = document.querySelectorAll('.ne-rv:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (w) {
      w.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { threshold: .12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () { document.querySelectorAll('.ne-rv:not(.is-in)').forEach(function (e) { if (e.getBoundingClientRect().top < innerHeight * 1.2) e.classList.add('is-in'); }); }, 3500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
